exports = module.exports = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-main[data-v-078753dd] {\n  /* 50= navbar  50  */\n  min-height: calc(100vh - 50px);\n  min-width: 100%;\n  position: relative;\n  overflow: hidden;\n}\n.fixed-header + .app-main[data-v-078753dd] {\n  padding-top: 50px;\n  height: 100vh;\n  overflow: auto;\n}\n.hasTagsView .app-main[data-v-078753dd] {\n  /* 84 = navbar + tags-view = 50 + 34 (38) */\n  min-height: calc(100vh - 90px);\n}\n.hasTagsView .fixed-header + .app-main[data-v-078753dd] {\n  padding-top: 84px;\n}\n", ""]);

// exports
